<form [formGroup]="movementScheduleTableForm">
    <!-- Edit Mode Table: viewMode >= 2 -->
    <table
        class="ham-table"
        *ngIf="
            mode === viewModes.EDIT &&
            movementScheduleTableForm != null &&
            movementScheduleTableForm.controls['dataSource'] != null
        "
    >
        <!-- Header Row -->
        <thead>
            <tr>
                <th class="descriptionColumn">
                    <div class="header-content">
                        <ng-content></ng-content>
                        <span *ngIf="tableNumber && tableNumber != null">
                            {{ tableNumber + ' ' + selectedFliName }}</span
                        >
                        <span *ngIf="!tableNumber"> {{ selectedFliName }}</span>
                    </div>
                </th>
                <th class="numberColumn previousYear">
                    {{ openDate | dateLocale: undefined : undefined : undefined : undefined : true }}
                </th>
                <th class="numberColumn extra-column">
                    <input
                        class="extra-column-title-input"
                        hamInput
                        type="text"
                        [formControl]="
                            movementScheduleTableForm.controls['headers']['controls']['header1']['controls'][
                                reportLocale
                            ]
                        "
                        [placeholder]="'Description'"
                    />
                </th>
                <th class="numberColumn extra-column">
                    <input
                        class="extra-column-title-input"
                        hamInput
                        type="text"
                        [formControl]="
                            movementScheduleTableForm.controls['headers']['controls']['header2']['controls'][
                                reportLocale
                            ]
                        "
                        [placeholder]="'Description'"
                    />
                </th>
                <th class="numberColumn extra-column">
                    <input
                        class="extra-column-title-input"
                        hamInput
                        type="text"
                        [formControl]="
                            movementScheduleTableForm.controls['headers']['controls']['header3']['controls'][
                                reportLocale
                            ]
                        "
                        [placeholder]="'Description'"
                    />
                </th>
                <th class="numberColumn extra-column">
                    <input
                        class="extra-column-title-input"
                        hamInput
                        type="text"
                        [formControl]="
                            movementScheduleTableForm.controls['headers']['controls']['header4']['controls'][
                                reportLocale
                            ]
                        "
                        [placeholder]="'Description'"
                    />
                </th>
                <th class="numberColumn currentYear">
                    {{ closeDate | dateLocale: undefined : undefined : undefined : undefined : true }}
                </th>
            </tr>
        </thead>

        <tbody formArrayName="dataSource">
            <tr
                *ngFor="let row of movementScheduleTableForm.controls['dataSource']['controls']; let i = index"
                [formGroupName]="i"
                [ngClass]="{ aumAlert: rowsHighlight[i] }"
            >
                <td class="descriptionColumn">
                    <input hamInput type="text" formControlName="text" disabled />
                </td>
                <td
                    class="numberColumn previousYear"
                    [ngClass]="{
                        todoHighlight:
                            highlightTodos &&
                            (row?.value?.openValue === '' ||
                                row?.value?.openValue === '-' ||
                                row?.value?.openValue == null),
                        aumAlert: rowsHighlight[i]
                    }"
                >
                    <input hamInput type="number" formControlName="openValue" disabled />
                </td>
                <td
                    class="numberColumn extra-column"
                    [ngClass]="{
                        todoHighlight:
                            highlightTodos &&
                            (row?.value?.column1 === '' || row?.value?.column1 === '-' || row?.value?.column1 == null),
                        'as-disabled': !editableData
                    }"
                >
                    <input
                        hamInput
                        type="number"
                        formControlName="column1"
                        placeholder="{{ 'aumico_notes_table_with_form_enter_placeholder' | i18next }}"
                        [readonly]="!editableData"
                    />
                </td>
                <td
                    class="numberColumn extra-column"
                    [ngClass]="{
                        todoHighlight:
                            highlightTodos &&
                            (row?.value?.column2 === '' || row?.value?.column2 === '-' || row?.value?.column2 == null),
                        'as-disabled': !editableData
                    }"
                >
                    <input
                        hamInput
                        type="number"
                        formControlName="column2"
                        placeholder="{{ 'aumico_notes_table_with_form_enter_placeholder' | i18next }}"
                        [readonly]="!editableData"
                    />
                </td>
                <td
                    class="numberColumn extra-column"
                    [ngClass]="{
                        todoHighlight:
                            highlightTodos &&
                            (row?.value?.column3 === '' || row?.value?.column3 === '-' || row?.value?.column3 == null),
                        'as-disabled': !editableData
                    }"
                >
                    <input
                        hamInput
                        type="number"
                        formControlName="column3"
                        placeholder="{{ 'aumico_notes_table_with_form_enter_placeholder' | i18next }}"
                        [readonly]="!editableData"
                    />
                </td>
                <td
                    class="numberColumn extra-column"
                    [ngClass]="{
                        todoHighlight:
                            highlightTodos &&
                            (row?.value?.column4 === '' || row?.value?.column4 === '-' || row?.value?.column4 == null),
                        'as-disabled': !editableData
                    }"
                >
                    <input
                        hamInput
                        type="number"
                        formControlName="column4"
                        placeholder="{{ 'aumico_notes_table_with_form_enter_placeholder' | i18next }}"
                        [readonly]="!editableData"
                    />
                </td>
                <td
                    class="numberColumn currentYear"
                    [ngClass]="{
                        todoHighlight:
                            highlightTodos &&
                            (row?.value?.closeValue === '' ||
                                row?.value?.closeValue === '-' ||
                                row?.value?.closeValue == null),
                        aumAlert: rowsHighlight[i]
                    }"
                >
                    <input hamInput type="number" formControlName="closeValue" disabled />
                </td>
            </tr>
        </tbody>

        <tfoot>
            <tr [formGroup]="movementScheduleTableForm.get('totalRow')">
                <td class="descriptionColumn">
                    <input
                        hamInput
                        type="text"
                        formControlName="text"
                        placeholder="{{ 'aumico_notes_table_with_form_total' | i18next }}"
                    />
                </td>
                <td class="numberColumn previousYear" [class]="{'as-disabled': true}">
                    <input hamInput type="number" formControlName="openValue" [readonly]="true" />
                </td>
                <td class="numberColumn extra-column" [class]="{'as-disabled': true}">
                    <input hamInput type="number" formControlName="column1" [readonly]="true" />
                </td>
                <td class="numberColumn extra-column" [class]="{'as-disabled': true}">
                    <input hamInput type="number" formControlName="column2" [readonly]="true" />
                </td>
                <td class="numberColumn extra-column" [class]="{'as-disabled': true}">
                    <input hamInput type="number" formControlName="column3" [readonly]="true" />
                </td>
                <td class="numberColumn extra-column" [class]="{'as-disabled': true}">
                    <input hamInput type="number" formControlName="column4" [readonly]="true" />
                </td>
                <td class="numberColumn currentYear" [class]="{'as-disabled': true}">
                    <input hamInput type="number" formControlName="closeValue" [readonly]="true" />
                </td>
            </tr>
        </tfoot>
    </table>

    <!-- Preview Mode Table: viewMode <= 1 -->

    <table class="ham-table previewMode" *ngIf="mode === viewModes.PREVIEW">
        <!-- Header Row -->
        <thead>
            <tr>
                <th class="descriptionColumn">
                    <span *ngIf="tableNumber"> {{ tableNumber + ' ' + selectedFliName }}</span>
                    <span *ngIf="!tableNumber"> {{ selectedFliName }}</span>
                </th>
                <th class="numberColumn previousYear">
                    <span>{{ openDate | dateLocale: undefined : undefined : undefined : undefined : true }}</span>
                </th>
                <th class="numberColumn extra-column">
                    <span>{{
                        movementScheduleTableForm.controls['headers']['controls']['header1']['controls'][reportLocale]
                            .value
                    }}</span>
                </th>
                <th class="numberColumn extra-column">
                    <span>{{
                        movementScheduleTableForm.controls['headers']['controls']['header2']['controls'][reportLocale]
                            .value
                    }}</span>
                </th>
                <th class="numberColumn extra-column">
                    <span>{{
                        movementScheduleTableForm.controls['headers']['controls']['header3']['controls'][reportLocale]
                            .value
                    }}</span>
                </th>
                <th class="numberColumn extra-column">
                    <span>{{
                        movementScheduleTableForm.controls['headers']['controls']['header4']['controls'][reportLocale]
                            .value
                    }}</span>
                </th>
                <th class="numberColumn currentYear">
                    <span>{{ closeDate | dateLocale: undefined : undefined : undefined : undefined : true }}</span>
                </th>
            </tr>
        </thead>

        <tbody formArrayName="dataSource">
            <tr
                *ngFor="let row of movementScheduleTableForm.controls['dataSource']['controls']; let i = index"
                [formGroupName]="i"
                [ngClass]="{ aumAlert: rowsHighlight[i] }"
            >
                <td class="descriptionColumn">
                    <span>{{ row.value.text }}</span>
                </td>
                <td
                    class="numberColumn previousYear"
                    [ngClass]="{
                        todoHighlight:
                            highlightTodos &&
                            (row?.value?.openValue === '' ||
                                row?.value?.openValue === '-' ||
                                row?.value?.openValue == null),
                        aumAlert: rowsHighlight[i]
                    }"
                >
                    <span>{{ row.value.openValue | finNumber }}</span>
                </td>
                <td
                    class="numberColumn extra-column"
                    [ngClass]="{
                        todoHighlight:
                            highlightTodos &&
                            (row?.value?.column1 === '' || row?.value?.column1 === '-' || row?.value?.column1 == null)
                    }"
                >
                    <span>{{ row.value.column1 | finNumber }}</span>
                </td>
                <td
                    class="numberColumn extra-column"
                    [ngClass]="{
                        todoHighlight:
                            highlightTodos &&
                            (row?.value?.column2 === '' || row?.value?.column2 === '-' || row?.value?.column2 == null)
                    }"
                >
                    <span>{{ row.value.column2 | finNumber }}</span>
                </td>
                <td
                    class="numberColumn extra-column"
                    [ngClass]="{
                        todoHighlight:
                            highlightTodos &&
                            (row?.value?.column3 === '' || row?.value?.column3 === '-' || row?.value?.column3 == null)
                    }"
                >
                    <span>{{ row.value.column3 | finNumber }}</span>
                </td>
                <td
                    class="numberColumn extra-column"
                    [ngClass]="{
                        todoHighlight:
                            highlightTodos &&
                            (row?.value?.column4 === '' || row?.value?.column4 === '-' || row?.value?.column4 == null)
                    }"
                >
                    <span>{{ row.value.column4 | finNumber }}</span>
                </td>
                <td
                    class="numberColumn currentYear"
                    [ngClass]="{
                        todoHighlight:
                            highlightTodos &&
                            (row?.value?.closeValue === '' ||
                                row?.value?.closeValue === '-' ||
                                row?.value?.closeValue == null),
                        aumAlert: rowsHighlight[i]
                    }"
                >
                    <span>{{ row.value.closeValue | finNumber }}</span>
                </td>
            </tr>
        </tbody>

        <tfoot>
            <tr>
                <td class="descriptionColumn">
                    <span>{{ movementScheduleTableForm.get('totalRow.text')?.value }}</span>
                </td>
                <td class="numberColumn previousYear">
                    <span>{{ movementScheduleTableForm.get('totalRow.openValue')?.value | finNumber }}</span>
                </td>
                <td class="numberColumn extra-column">
                    <span>{{ movementScheduleTableForm.get('totalRow.column1')?.value | finNumber }}</span>
                </td>
                <td class="numberColumn extra-column">
                    <span>{{ movementScheduleTableForm.get('totalRow.column2')?.value | finNumber }}</span>
                </td>
                <td class="numberColumn extra-column">
                    <span>{{ movementScheduleTableForm.get('totalRow.column3')?.value | finNumber }}</span>
                </td>
                <td class="numberColumn extra-column">
                    <span>{{ movementScheduleTableForm.get('totalRow.column4')?.value | finNumber }}</span>
                </td>
                <td class="numberColumn currentYear">
                    <span>{{ movementScheduleTableForm.get('totalRow.closeValue')?.value | finNumber }}</span>
                </td>
            </tr>
        </tfoot>
    </table>
</form>

<!-- Footnote Section -->
<div class="footnote-section" *ngIf="hasFootnotes && mode === viewModes.EDIT">
    <label for="footnote">{{ 'aumico_notes_footnote_label' | i18next }}</label>
    <textarea
        hamInput
        [hideRemoveXButton]="true"
        [placeholder]="'aumico_notes_footnote_placeholder' | i18next"
        [formControl]="movementScheduleTableForm.get('footnote')"
    ></textarea>
</div>
